import React, { ChangeEvent, useCallback } from 'react';
import { DropTargetMonitor } from 'react-dnd';

import { TargetBox } from './TargetBox';

type ContainerProps = {
  onFileDropped: (files: File[]) => void;
};

export const Container = ({ onFileDropped }: ContainerProps) => {
  const handleFileDrop = useCallback((item: any, monitor: DropTargetMonitor) => {
    if (monitor) {
      const files = monitor.getItem().files;
      onFileDropped(files);
    }
  }, []);

  const handleFileOpen = useCallback((event: ChangeEvent<HTMLInputElement>) => {
    if (event && event.target) {
      onFileDropped(Array.from(event.target.files));
    }
  }, []);

  return (
    <>
      <TargetBox onDrop={handleFileDrop} onOpen={handleFileOpen} />
    </>
  );
};
